import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
 
@Injectable({ providedIn: 'root' })
export class StatusAuthGuard implements CanActivate {
    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        // Public status page auth/SSO is handled directly in StatusMainPageComponent.
        return true;
    }
}
